import { Link } from "react-router-dom";
import { Reveal, Kicker } from "./Reveal";

export const ClosingMessage = () => (
  <section className="px-6 py-20 sm:py-28 bg-blush/40 grain relative overflow-hidden" data-testid="closing-message">
    <div className="absolute -bottom-28 -right-24 w-96 h-96 bg-terracotta/15 organic-blob-alt blur-3xl" />
    <div className="relative max-w-5xl mx-auto">
      <Reveal>
        <Kicker>One last yarn</Kicker>
        <div className="font-display font-light text-3xl sm:text-4xl lg:text-[2.9rem] leading-[1.2] text-charcoal space-y-5">
          <p>Therapy doesn't always have to happen in a therapy room.</p>
          <p>Some people yarn better sitting together. Some yarn better walking.</p>
          <p>Some young people connect while doing something they enjoy.</p>
          <p>Sometimes confidence grows through doing.</p>
          <p>Sometimes mentoring creates the relationship where <span className="italic text-terracotta">another story becomes possible.</span></p>
          <p>And sometimes changing the story about what somebody believes they can do can change what becomes possible next.</p>
        </div>
        <p className="mt-10 text-base lg:text-lg leading-relaxed text-earth max-w-3xl">
          Ngawilyi Narrative brings story, relationship, culture, mentoring and everyday experiences together
          around what matters to the person.
        </p>
        <p className="mt-6 font-display italic text-2xl sm:text-3xl text-terracotta">
          Healing through story. Strength through connection.
        </p>
        <div className="mt-10 flex flex-wrap gap-4">
          <Link data-testid="closing-private-btn" to="/private-supports" className="rounded-full bg-terracotta px-8 py-4 text-sm font-bold uppercase tracking-widest text-cream transition-transform duration-300 hover:scale-105">
            Request Private Support
          </Link>
          <Link data-testid="closing-ndis-btn" to="/ndis-supports" className="rounded-full border-2 border-charcoal px-8 py-[14px] text-sm font-bold uppercase tracking-widest text-charcoal transition-colors duration-300 hover:bg-charcoal hover:text-cream">
            Request NDIS Support
          </Link>
          <Link data-testid="closing-programs-btn" to="/programs" className="rounded-full border-2 border-ochre/60 px-8 py-[14px] text-sm font-bold uppercase tracking-widest text-earth transition-colors duration-300 hover:border-terracotta hover:text-terracotta">
            Explore Our Programs
          </Link>
        </div>
      </Reveal>
    </div>
  </section>
);

export const PolicyLinks = () => (
  <div className="mt-8 flex flex-wrap items-center gap-x-6 gap-y-2 text-sm" data-testid="policy-links">
    <span className="text-earth/60">Before you submit, you might like to read:</span>
    <Link to="/privacy" className="font-bold text-terracotta hover:text-earth transition-colors">Privacy</Link>
    <Link to="/privacy" className="font-bold text-terracotta hover:text-earth transition-colors">Consent & Confidentiality</Link>
    <Link to="/privacy" className="font-bold text-terracotta hover:text-earth transition-colors">Cancellation Policy</Link>
    <Link to="/privacy" className="font-bold text-terracotta hover:text-earth transition-colors">Service Agreements</Link>
  </div>
);

export const CrisisNote = () => (
  <div className="mt-8 rounded-3xl bg-charcoal/5 border border-charcoal/10 px-7 py-6" data-testid="crisis-note">
    <p className="text-sm leading-relaxed text-earth/85">
      <strong className="text-charcoal">Please know:</strong> Ngawilyi Narrative is not an emergency or crisis
      response service. If you or someone you know needs immediate support, call <strong>000</strong>,{" "}
      <strong>Lifeline 13 11 14</strong>, <strong>13YARN 13 92 76</strong> (Aboriginal & Torres Strait Islander
      crisis line) or <strong>Kids Helpline 1800 55 1800</strong>.
    </p>
  </div>
);
